import { HubConnectionBuilder, HubConnection, LogLevel } from "@microsoft/signalr";

const API_BASE = (import.meta.env.VITE_API_ORIGIN as string | undefined) ?? "";

/**
 * Builds a SignalR connection to the support hub. Auth rides the httpOnly
 * access_token cookie on the negotiate/WebSocket handshake (withCredentials),
 * so no token handling is needed here. Auto-reconnects on drop.
 */
export function createSupportConnection(): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(`${API_BASE}/hubs/support`, { withCredentials: true })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();
}
